import type React from "react";

import { Tab } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { MUITabs } from "shared/atoms/MUI";
import { useCurrentPatient } from "utils/hooks/useCurrentPatient";
import { useDevice } from "utils/hooks/useDevice/useDevice";

export const PatientSubMenu: React.FC = () => {
  const { t } = useTranslation();
  const { isMobileOrTablet } = useDevice();
  const navigate = useNavigate();
  const location = useLocation();
  const { patientId } = useParams<{ patientId: string }>();
  const PATH = `/patients/${patientId}/information`;

  const { patient } = useCurrentPatient();
  const hideLegacyHealthReports = patient?.providerGroupData?.us_provider_group_clinic?.name === "Motion MSK";

  return (
    <MUITabs
      value={location.pathname}
      onChange={(_event, newValue: string) => navigate(newValue)}
      aria-label="Patient information sub menu"
      scrollButtons="auto"
      variant={isMobileOrTablet ? "scrollable" : "standard"}
      centered
      data-testid="sub-menu"
    >
      <Tab
        label={t("patients.sub_menu.medical_record")}
        value={`${PATH}/journal`}
        data-testid="sub-menu-medical-record"
      />
      <Tab
        label={t("patients.sub_menu.sign_up_questions")}
        value={`${PATH}/sign-up-questions`}
        data-testid="sub-menu-sign-up-questions"
      />
      {!hideLegacyHealthReports && (
        <Tab
          label={t("patients.sub_menu.health_questionnaires_legacy")}
          value={`${PATH}/health-reports`}
          data-testid="sub-menu-reports"
        />
      )}
      <Tab
        label={t("patients.sub_menu.health_questionnaires")}
        value={`${PATH}/health-reports-v2`}
        data-testid="sub-menu-reports-v2"
      />
      <Tab label={t("patients.sub_menu.goal")} value={`${PATH}/goals`} data-testid="sub-menu-goals" />
      <Tab
        label={t("patients.sub_menu.personal_details")}
        value={`${PATH}/personal`}
        data-testid="sub-menu-personal-details"
      />
    </MUITabs>
  );
};
